export default __webpack_public_path__ + "static/media/Cooper Black Regular.dbe0cbaa.ttf";